<template lang="pug">
  div
    v-row(no-gutters)
      v-col.pr-8.shrink
        div.sticky.bg-white(style="width: 300px; top: 106px;")
          .text-md.font-semibold.text-neutral-700.px-6.py-2.round-md.mb-2.bg-neutral-200 {{ $t('panel.claim_message_template') }}
      v-col.grow.bg-neutral-200(style="min-height: calc(100dvh - 72px); padding: 32px 56px;")
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            yz-btn.ml-n3(icon-only, size="lg" icon="mdi-arrow-left" :icon-size="24" @click="goBack")
          v-col.ml-3
            .yz-heading-5 {{ $t('panel.claim_message_template') }}

        yz-card.mt-4.pa-6(outlined)
          // Loading State
          div(v-if="isLoading")
            yz-skeleton-loader(type="card-heading, divider, list-item-three-line, divider, card-heading, list-item-avatar-three-line")

          // Error State
          div(v-else-if="isError")
            yz-empty-state-card(icon="mdi-alert-circle-outline" icon-color="yz-danger-500" :title="$t('error_message.unable_to_load_data')" :description="$t('error_message.please_try_again')" action-label="Retry" @action-click="fetchTemplate")

          // Main Content
          div(v-else)
            .yz-medium-body-md {{ $t('panel.message_template') }}

            .yz-regular-body-sm {{ $t('panel.message_template_description') }}

            yz-tabs.mt-4(v-model="activeTab")
              yz-tab(:label="$t('panel.single_claim')")
              yz-tab(:label="$t('panel.bulk_claim')")

            yz-divider

            .mt-4
              div(v-if="activeTab === 0")
                v-row(align="center" justify="space-between" no-gutters)
                  v-col
                    .yz-regular-body-sm {{ $t('panel.single_claim_description') }}

                  v-col.shrink
                    .d-flex.gap-2
                      yz-btn(v-if="singleClaimMessage" size="lg" :label="$t('panel.edit_template')" @click="openMessageTemplateDialog")
                      yz-btn(v-else secondary, size="lg" :label="$t('panel.set_now')" @click="openMessageTemplateDialog")

                .mt-7(v-if="singleClaimMessage")
                  .yz-medium-body-sm {{ $t('panel.message_preview') }}

                  yz-card.pa-0.mt-2(outlined)
                    div(style="padding: 24px 180px")
                      .yz-regular-body-sm.preview-message(v-html="singleClaimMessage")

              div(v-if="activeTab === 1")
                v-row(align="center" justify="space-between" no-gutters)
                  v-col
                    .yz-regular-body-sm {{ $t('panel.bulk_claim_description') }}
                  v-col.shrink
                    .d-flex.gap-2
                      yz-btn(v-if="bulkClaimMessage" size="lg" :label="$t('panel.edit_template')" @click="openMessageTemplateDialog")
                      yz-btn(v-else secondary, size="lg" :label="$t('panel.set_now')" @click="openMessageTemplateDialog")

                .mt-7(v-if="bulkClaimMessage")
                  .yz-medium-body-sm {{ $t('panel.message_preview') }}

                  yz-card.pa-0.mt-2(outlined)
                    div(style="padding: 24px 180px")
                      .yz-regular-body-sm.preview-message(v-html="bulkClaimMessage")

    // Dialogs
    message-template-setup(v-if="showMessageTemplateDialog" :open.sync="showMessageTemplateDialog" :claim-type="claimType" :parent-template="activeTab === 0 ? singleClaimMessage : bulkClaimMessage" @saved="fetchTemplate")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MessageTemplateSetup from '@/components/clinic/panel/dialogs/MessageTemplateSetup.vue'

export default {
  components: {
    MessageTemplateSetup
  },
  data() {
    return {
      activeTab: 0,
      showMessageTemplateDialog: false,
      singleClaimMessage: null,
      bulkClaimMessage: null,
      isLoading: false,
      isError: false
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    claimType() {
      return this.activeTab === 0 ? 'single' : 'bulk'
    }
  },
  mounted() {
    this.fetchTemplate()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name) {
      to.meta.hasPrevPath = true
    }
    next()
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchTemplate() {
      this.isLoading = true
      this.isError = false
      const params = {
        fields: 'single_claim_message,bulk_claim_message'
      }
      try {
        const {
          data: { single_claim_message, bulk_claim_message }
        } = await this.$axios.get(`/clinics/${this.company.slug}`, { params })
        this.singleClaimMessage = single_claim_message
        this.bulkClaimMessage = bulk_claim_message
      } catch (error) {
        console.error('Error fetching template:', error)
        this.isError = true
        await this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    },
    goBack() {
      if (this.$route?.meta?.hasPrevPath) {
        this.$router.back()
        return
      }
      this.$router.push('/admin/clinic/settings')
    },
    openMessageTemplateDialog() {
      this.showMessageTemplateDialog = true
    }
  }
}
</script>

<style scoped>
.sticky {
  position: sticky;
  z-index: 1;
}

::v-deep .preview-message p {
  margin-bottom: 0;
}
</style>
